import CRUDService from './crud-service';
import {CollegeMajor} from 'src/types/college';

export default new CRUDService<CollegeMajor>('/v1/lists/college-majors');
